<template>
  <v-row>
    <v-col v-if="title" cols="12">
      <div class="text-h6 font-weight-bold py-2">
        {{title}}
      </div>
    </v-col>
    <v-col cols="12" md="6" class=" px-5 py-2" v-for="(image,index) in images" :key="index">
      <v-card elevation="2" class="hidden-md-and-up">
        <v-img :aspect-ratio="16/10" :width="width" class="grey lighten-2" :alt=image.alt
          :src="`https://storage.googleapis.com/porte-parapluies.appspot.com/${path}/00${index+1}s.webp`">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="grey lighten-5"/>
            </v-row>
          </template>
        </v-img>
      </v-card>
      <v-card elevation="2" @click="image.overlay = true" class="hidden-sm-and-down">
        <v-img :aspect-ratio="16/10" :width="width" class="grey lighten-2" :alt=image.alt
          :src="`https://storage.googleapis.com/porte-parapluies.appspot.com/${path}/00${index+1}s.webp`">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="grey lighten-5"/>
            </v-row>
          </template>
        </v-img>
      </v-card>
      <v-overlay
        :value=image.overlay
        @click="image.overlay = false"
        opacity="0.6">
        <v-img
          :src="`https://storage.googleapis.com/porte-parapluies.appspot.com/${path}/00${index+1}.webp`"
          max-width="100vw">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="grey lighten-5"/>
            </v-row>
          </template>
        </v-img>
      </v-overlay>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'GameImage',
  props: {
    title: String,
    path: String,
    images: Array
  },
}
</script>

<style>
</style>